import { FormattedMessage } from 'react-intl';
import { OfferPresentationPriority } from '@ocx/graphql';
import { OPTIMIZED_HOME_OFFERS_FILTER, useOffers } from '@ocx/data-offers';
import { LocationSelectorController, useOffersLocationsGeoFilter } from '@ocx/feat-local-offers';

import { NoDataView, ScreenLoaderBackdrop } from '@ocx/ui';
import { useConfiguration } from '@ocx/data-configuration';
import { useHomeRefreshing, useRegisterRefetch } from '../context/home-refresh.context';
import { HomeFeaturedOffersController } from './home-featured-offers.controller';
import { messages } from './home-offers-featured-strip.messages';

/**
 * Home page offers block when the main catalog is on the Offers tab (`OffersGridLocation.Tab`):
 * show the featured strip here only (optional location when local offers are on).
 */
export const HomeOffersFeaturedStripController = () => {
  const {
    config: { localOffers, loyaltyProgram },
  } = useConfiguration();

  const locationsGeoFilter = useOffersLocationsGeoFilter({
    includeCoordinatesWhenShowingAll: false,
  });

  const {
    offers,
    refetch: refetchOffers,
    loading,
  } = useOffers({
    variables: {
      ...OPTIMIZED_HOME_OFFERS_FILTER,
      first: loyaltyProgram.homePageOffersLimit,
      locationsGeoFilter,
      presentationPriorityIncludes: [OfferPresentationPriority.Featured],
    },
    persistToStorage: true,
  });

  useRegisterRefetch(refetchOffers);
  useHomeRefreshing(loading && offers.length > 0);

  return (
    <>
      <ScreenLoaderBackdrop open={loading && !offers.length} />
      {localOffers.enabled && <LocationSelectorController />}
      {!loading && !offers.length && (
        <NoDataView
          title={<FormattedMessage {...messages['home-offers-featured-strip.no-offers-available-title']} />}
        />
      )}
      <HomeFeaturedOffersController offers={offers} />
    </>
  );
};
